import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import { Column, DownloadButton, DownloadButtonProps } from '../../../../3-pattern';
import { UserContext } from '../../../../../providers/userContextProvider';

const FETCH_ORGANIZATION_USER = `query fetchOrganizationUsers($input: FetchOrganizationUsersInput!) {
    fetchOrganizationUsers(input: $input) {
      totalCount
      organizationUsers {
        id
        firstName
        lastName
        email
        organization { name }
        lastLoggedInAt
        loginStatus
      }
    }
  }
`;

const DownloadOrganizationUser = () => {
  const { t } = useTranslation(['orgSettings']);
  const { activeOrganization } = useContext(UserContext);

  const columns: Column[] = [
    { gqlAlias: 'firstName', header: t('orgSettings:accessUsers.firstName') },
    { gqlAlias: 'lastName', header: t('orgSettings:accessUsers.lastName') },
    { gqlAlias: 'email', header: t('orgSettings:accessUsers.email') },
    { gqlAlias: 'organization.name', header: t('orgSettings:accessUsers.organization') },
    { gqlAlias: 'loginStatus', header: t('orgSettings:accessUsers.loginStatus') },
    { gqlAlias: 'lastLoggedInAt', header: t('orgSettings:accessUsers.lastLoginAt') },
  ];

  const config: DownloadButtonProps = {
    gql: FETCH_ORGANIZATION_USER,
    filter: { childrenForOrganizationId: activeOrganization.id },
    queryPath: 'fetchOrganizationUsers',
    datasetPath: 'organizationUsers',
    columns,
    fileName: `${t('orgSettings:accessUsers.title')}_${dayjs().format('YYYY-MM-DD')}`,
    sortField: 'createdAt',
    sortDesc: false,
  };

  return (
    <DownloadButton
      configurable
      gql={config.gql}
      fileName={config.fileName}
      filter={config.filter}
      queryPath={config.queryPath}
      datasetPath={config.datasetPath}
      columns={config.columns}
      sortField={config.sortField}
      sortDesc={config.sortDesc}
    />
  );
};

export default DownloadOrganizationUser;
